class NavService {}

export default new NavService();
